/* global angular swal */
import './style.less';
import { findIndex } from 'lodash';

export default function($scope, $log, $stateParams, ApiClass, ProfileClass, Upload, Swal) {
  'ngInject';
  const vm = this;
  vm.$onChanges = activate;
  $scope.formData = {};
  $scope.routeParams = $stateParams;
  $scope.eventId = $stateParams.eventId;
  $scope.reultsQuired = false;
  $scope.includeCourseMaterials = false;

  // Attendance Sheets Functions
  $scope.removeEventAttendanceSheet = () => {
    const event = {
      course_id: $stateParams.courseid,
      event_id: $stateParams.eventid,
      pdf_uploaded: false,
      attendance_url: false
    };
    return ApiClass.eventsIdPatch({ id: $stateParams.eventid, manage: true }, { event })
      .then(() => {
        $scope.event.attendance_url = false;
      })
      .catch(error => {
        errorSwal();
        $log.error(error);
        throw error;
      });
  };

  $scope.updateEventPublicMaterials = publicMaterials => {
    const event = {
      course_id: $stateParams.courseid,
      event_id: $stateParams.eventid,
      publicMaterials
    };
    return ApiClass.eventsIdPatch({ id: $stateParams.eventid, manage: true }, { event })
      .then(() => {
        $scope.event.publicMaterials = publicMaterials;
        Swal.toast('Event updated!');
      })
      .catch(error => {
        errorSwal();
        $log.error(error);
        throw error;
      });
  };

  $scope.removeLocationAttendanceSheet = index => {
    $scope.event.locations[index].attendance_url = false;
    $scope.event.locations[index].pdf_uploaded = false;
    const locations = $scope.event.locations.filter(({ primary }) => !primary);
    const event = { course_id: $stateParams.courseid, event_id: $stateParams.eventid, locations };
    ApiClass.eventsIdPatch({ id: $stateParams.eventid, manage: true }, { event }).catch(error => {
      errorSwal();
      $log.error(error);
      throw error;
    });
  };
  // Attendance Sheets ^

  // Course Material Functions
  $scope.removeCourseFile = index => {
    const courseMaterials = angular.copy($scope.courseMaterials);
    courseMaterials.fileUrls.splice(index, 1);

    return ApiClass.coursesIdTypePut(
      { id: $stateParams.courseid, type: 'materials' },
      { eventMaterial: courseMaterials },
      { queryParams: { manage: true } }
    )
      .then(() => {
        $scope.courseMaterials.fileUrls = courseMaterials.fileUrls;
      })
      .catch(error => {
        errorSwal();
        $log.error(error);
        throw error;
      });
  };
  // Course Material ^

  // Event Material Functions
  $scope.removeMiscFile = index => {
    const eventMisc = angular.copy($scope.event.misc_url);
    eventMisc.splice(index, 1);
    const event = { course_id: $stateParams.courseid, event_id: $stateParams.eventid, misc_url: eventMisc };
    ApiClass.eventsIdPatch({ id: $stateParams.eventid, manage: true }, { event })
      .then(() => {
        $scope.event.misc_url = eventMisc;
      })
      .catch(error => {
        errorSwal();
        $log.error(error);
        throw error;
      });
  };

  $scope.uploadMisc = file => {
    if (!file) return;
    $scope.uploadProgress = 'Uploading...';
    ApiClass.companiesIdTypePut(
      { manage: true, id: ProfileClass.company_id, type: 'policies' },
      {
        policy: 'event',
        event_id: $stateParams.eventid,
        file_type: file.type,
        file_name: file.name
      }
    )
      .then(({ data: { item: s3Policy } }) => {
        $scope.s3Policy = s3Policy;
        return Upload.upload({
          url: s3Policy.filePolicy.action,
          data: s3Policy.filePolicy.fields,
          file: file,
          method: 'POST',
          skipAuthorization: true
        }).then(
          () => {
            const eventFile = {
              url: $scope.s3Policy.link,
              name: file.name,
              date: new Date().toISOString()
            };
            $scope.event.misc_url = $scope.event.misc_url ? $scope.event.misc_url : [];
            $scope.event.misc_url.push(eventFile);
            const event = {
              course_id: $scope.event.course_id,
              event_id: $scope.event.event_id,
              misc_url: $scope.event.misc_url
            };
            ApiClass.eventsIdPatch({ id: $stateParams.eventid, manage: true }, { event }).then(res => {
              $scope.uploadProgress = '';
              $scope.formData.fileToUpload = false;
            });
          },
          error => {
            errorSwal();
            $log.error(error);
            throw error;
          }
        );
      })
      .catch(error => {
        errorSwal();
        $log.error(error);
        throw error;
      });
  };

  // Event Material ^

  function errorSwal() {
    return swal('Oops!', 'Looks like there was an error uploading your file. Try again', 'error');
  }

  function activate() {
    if (vm.event) {
      $scope.event = vm.event;
      $scope.event.publicMaterials = !!$scope.event.publicMaterials;
      $scope.publicMaterials = !!$scope.event.publicMaterials;
      $scope.courseMaterials = vm.event.eventMaterials;
      $scope.event.includeCourseMaterials =
        $scope.event.includeCourseMaterials === undefined ? false : $scope.event.includeCourseMaterials;
      $scope.resultsQueried = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/materials/controller.js